module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2020.929693d3.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2020.png
// module id = 1150
// module chunks = 0